var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardGradientEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 319 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618873496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 76",
    filter: "url(#filter0_f_6124_1024)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.5,
    cy: 57,
    rx: 115.5,
    ry: 13,
    fill: "var(--fill-0, #5694CB)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 77",
    filter: "url(#filter1_f_6124_1024)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.5,
    cy: 63.5,
    rx: 19.5,
    ry: 55,
    transform: "rotate(90 159.5 63.5)",
    fill: "var(--fill-0, #CAB294)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6124_1024",
    x: 0,
    y: 0,
    width: 319,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22,
    result: "effect1_foregroundBlur_6124_1024"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6124_1024",
    x: 60.5,
    y: 0.00000236425,
    width: 198,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22,
    result: "effect1_foregroundBlur_6124_1024"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGradientEllipse);
export default __webpack_public_path__ + "static/media/card-gradient-ellipse.ca511caf492c4f4f05b52e4fd9d40923.svg";
export { ForwardRef as ReactComponent };